import { Column, SelectionSetInput, SelectionSetLabel, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';

type SelectionInputProps = {
    title: string;
    value: string;
    icon: () => JSX.Element;
};

export const SelectionInput = ({ title, value, icon }: SelectionInputProps) => {
    return (
        <Column span={6} spanXs={6} key={value}>
            <SelectionSetInput value={value}>
                <SelectionSetLabel>
                    {icon()}
                    <Typography fontSkin="body-standard-bold">{title}</Typography>
                    <Typography fontSkin="body-small" textColor="subtle">
                        {__('Included')}
                    </Typography>
                </SelectionSetLabel>
            </SelectionSetInput>
        </Column>
    );
};
